const PAGE_SIZE = 5;

export const getTotalPages = (itemsCount: number) =>
    Math.ceil(itemsCount / PAGE_SIZE);

export const isOnPage = (index: number, page: number) =>
    index >= (page - 1) * PAGE_SIZE && index < page * PAGE_SIZE;
